import { cn } from '@repo/tailwind-config/tailwind.functions'

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-grey-light-hover rounded-lg', className)}
      {...props}
    />
  )
}
